import React from "react";
import PropTypes from "prop-types";
import {ToggleField} from "../../core";
import {EXPECT_A_GIFT, MessageField, RECIPIENT_EMAIL_FIELD, RecipientEmailField} from "../fields";

const PHYSICAL_MESSAGE_MAX_LENGTH = 150;

export const expectAGiftHandler = (isExpectAGift, setFieldValue, setTouched) => {
    setFieldValue(EXPECT_A_GIFT, isExpectAGift);
    if (isExpectAGift === false) {
        setFieldValue(RECIPIENT_EMAIL_FIELD, '');
        setTouched({RECIPIENT_EMAIL_FIELD: false}, false);
    }
};

export const ExpectAGiftButton = ({label, expectAGift, setFieldValue, setTouched}) => (
    <React.Fragment>
        <MessageField maximumLength={PHYSICAL_MESSAGE_MAX_LENGTH} />
        <ToggleField
            name="expectAGift"
            label={label}
            toggleClickHandler={(isExpectingAGift) =>expectAGiftHandler(isExpectingAGift, setFieldValue, setTouched)}
        />
        {expectAGift && <RecipientEmailField />}
    </React.Fragment>
);

ExpectAGiftButton.propTypes = {
    label: PropTypes.string.isRequired,
    expectAGift: PropTypes.bool.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    setTouched: PropTypes.func.isRequired,
};
